import client from 'app/client';
import { OperationResponse } from 'api/actor';

/**
 * Comptes bancaires d'une personne (pivot). Pour une corporate, le personId
 * vaut son personneMoraleId (la Personne d'une PM partage son Guid). Endpoints
 * back-office existants sous /backoffice/comptes.
 */
export interface CompteBancaireDto {
  id: string;
  personId: string;
  iban: string;
  bic?: string | null;
  label: string;
  isDefault: boolean;
  storedFileId?: string | null;
  creationTime: string;
}

export interface CreateCompteBancaireCommand {
  personId: string;
  iban: string;
  bic?: string | null;
  label: string;
  isDefault: boolean;
}

export interface UpdateCompteBancaireCommand {
  iban: string;
  bic?: string | null;
  label: string;
  isDefault: boolean;
}

/** L'endpoint renvoie un wrapper { bankAccounts: [...] }, pas un tableau brut. */
interface GetComptesBancairesResponse {
  bankAccounts: CompteBancaireDto[];
}

export async function getComptesBancairesByPersonne(
  personId: string,
): Promise<CompteBancaireDto[]> {
  const { data } = await client.get<GetComptesBancairesResponse>(
    `/backoffice/comptes/personne/${personId}`,
  );
  return data?.bankAccounts ?? [];
}

export async function createCompteBancaire(
  command: CreateCompteBancaireCommand,
): Promise<OperationResponse> {
  const { data } = await client.post<OperationResponse>('/backoffice/comptes', command);
  return data;
}

export async function updateCompteBancaire(
  id: string,
  command: UpdateCompteBancaireCommand,
): Promise<OperationResponse> {
  const { data } = await client.put<OperationResponse>(`/backoffice/comptes/${id}`, command);
  return data;
}

export async function deleteCompteBancaire(id: string): Promise<OperationResponse> {
  const { data } = await client.delete<OperationResponse>(`/backoffice/comptes/${id}`);
  return data;
}
